import React from 'react';
import PropTypes from 'prop-types';
import {Paper} from "material-ui";
import Subheader from 'material-ui/Subheader';
import {connect} from "react-redux";
import Error from "../../components/common/Error/Error";
import Loading from "../../components/common/Loading/Loading";
import {fetchApp} from '../../store/apps/actions';
import style from '../../styles/styles';
import styles from './EditPagePage.css';
import {fetchPage, putPage} from "../../store/pages/actions";
import PageForm from "../../components/page/PageForm";
import {dispatchInfo} from "../../store/infos/actions";
import {PAGE_PAGE} from "../../constants/routes";
import withTranslation from "../../hoc/withTranslation";

export class EditPagePage extends React.Component {

    static propTypes = {
        app: PropTypes.object
    };

    static defaultProps = {};

    componentDidMount() {
        this.fetch();
    }

    componentWillUpdate(nextProps) {
        if (this.props.sending && !nextProps.sending) {
            let url = PAGE_PAGE
                .replace(':appId', this.props.app.id)
                .replace(':pageId', this.props.page.id);
            this.props.history.push(url);
        }
    }

    // Fetch

    fetch(appId = null, pageId = null) {
        this.fetchApplication(appId);
        this.fetchPage(appId, pageId);
    }

    fetchApplication(appId = null) {
        if (this.props.match) {
            const id = appId || this.props.match.params.appId;

            if (id) {
                this.props.fetchApp(id)
            }
        }
    }

    fetchPage(appId = null, pageId = null) {
        if (this.props.match) {
            const app = appId || this.props.match.params.appId;
            const page = pageId || this.props.match.params.pageId;

            if (app && page) {
                this.props.fetchPage(app, page, this.props.lang)
            }
        }
    }

    // Actions

    handleFormSubmit = async (formProps) => {
        await this.props.putPage(this.props.app.id, formProps, this.props.lang);
    };

    handleFormReset = () => {
        if (this.props.page) {
            //TODO : reset page
        }
    };

    // Render

    renderForm() {
        return (
            <div style={style.col} className="col-xs-12 col-sm-12 col-md-12">

                <Paper style={styles.editBox}>
                    <Subheader style={style.subHeader}>{this.props.page.title}</Subheader>
                    <div style={style.paper}>
                        <PageForm
                            onFormReset={this.handleFormReset}
                            onSubmit={this.handleFormSubmit}
                            initialValues={this.props.initialValues}
                            submitting={this.props.sending}
                            page={this.props.page}
                            enableReinitialize={true}
                        />
                    </div>
                    <div style={style.clear}/>
                </Paper>
            </div>
        );
    }

    render() {
        if (this.props.error) {
            return (
                <Error
                    title="Error"
                    subtitle="Could not load data"
                    paper={true}
                />
            );
        } else if (this.props.loading || !this.props.app || !this.props.page) {
            return <Loading paper={false}/>;
        } else {
            return (
                <div>
                    <h3 style={style.navigation}>{this.props.t('module.page.page_edit')}</h3>
                    <div className="row">
                        {this.renderForm()}
                    </div>
                </div>
            )
        }
    }
}

function mapStateToProps(state, ownProps) {
    let props = {
        loading: state.apps.pending || state.pages.pending,
        error: state.pages.error || state.apps.error,
        page: state.pages.currentPage,
        lang: state.ui.currentLang,
        app: state.apps.currentApplication,
        sending: state.pages.sending,
    };

    const page = state.pages.currentPage;
    if (page) {
        props.initialValues = {...page};
    }

    return props;
}

export default connect(mapStateToProps, {
    putPage,
    fetchApp,
    fetchPage,
    dispatchInfo
})(withTranslation(EditPagePage));



// WEBPACK FOOTER //
// src/containers/page/EditPagePage.js